<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm back-btn"
                :to="{ name: 'ProvisionList' }"
                ><i class="icon-left"></i>
              </router-link>
              <span>VoIP Configuration</span>
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">VoIP</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <form @submit.prevent="handleSubmission()" method="POST" novalidate>
          <div v-if="voip_setting_enable">
            <div class="row">
              <div class="col-md-4 sticky-top">
                <div class="card voip-status">
                  <div class="card-body">
                    <h4 class="card-common-title p-0 mb-4">
                      Change VoIP Status
                    </h4>
                    <ul>
                      <li>
                        <div class="voip-status-icon">
                          <i class="icon-calendar"></i>
                        </div>
                        <div class="voip-status-content">
                          <label class="control-label">Provisioned Date</label>
                          <h4>
                            {{
                              value.voip.provision_history.created_at ?? "N/A"
                            }}
                          </h4>
                        </div>
                      </li>
                      <li>
                        <div class="voip-status-icon">
                          <i class="icon-mail"></i>
                        </div>
                        <div class="voip-status-content">
                          <label class="control-label">Provisioned By</label>
                          <h4>
                            {{
                              value.voip.provision_history.creator.name ?? "N/A"
                            }}
                          </h4>
                        </div>
                      </li>
                      <li>
                        <div class="voip-status-icon">
                          <i class="icon-common-device"></i>
                        </div>
                        <div class="voip-status-content">
                          <label class="control-label d-block mb-2"
                            >Current Device Status</label
                          >
                          <span v-if="value.voip.status_str == 'NOT REGISTERED'"
                            ><i class="fa fa-circle text-danger"></i> Not
                            Registered</span
                          >
                          <span
                            v-else-if="value.voip.status_str == 'REGISTERED'"
                            ><i class="fa fa-circle text-success"></i>
                            Registered</span
                          >
                          <span
                            v-else-if="value.voip.status_str == 'REGISTERING'"
                            ><i class="fa fa-circle text-warning"></i>
                            Connecting</span
                          >
                          <span
                            v-else-if="value.voip.status_str == 'REGISTER FAIL'"
                            ><i class="fa fa-circle text-danger"></i> Failed To
                            Connect</span
                          >
                          <span v-else
                            ><i class="fa fa-circle text-danger"></i> Not
                            Registered</span
                          >
                        </div>
                      </li>
                    </ul>

                    <div class="mt-3 d-flex">
                      <button
                        type="button"
                        class="btn btn-cancel mr-2"
                        @click="restoreData"
                      >
                        Cancel
                      </button>
                      <button class="btn" type="submit" :disabled="is_loading">
                        {{ is_edit ? "Update" : "Create" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card">
                  <div class="overlay" v-if="is_loading">
                    <img src="/assets/images/loader.svg" alt="" />
                  </div>
                  <div class="card-body">
                    <div class="panel-body">
                      <div class="switch-row justify-content-between">
                        <h4 class="card-common-title p-0">
                          <i
                            class="fas fa-phone-alt mr-2"
                            aria-hidden="true"
                          ></i>
                          VoIP
                        </h4>
                        <el-switch
                          v-model="value.voip.voip_enable"
                          active-color="#009E9D"
                          inactive-color="#E5E5E5"
                          :disabled="!voip_setting_enable"
                        >
                        </el-switch>
                      </div>
                    </div>
                    <el-collapse-transition>
                      <div class="VoIP-content" v-show="value.voip.voip_enable">
                        <div class="pt-3">
                          <div class="row">
                            <div class="col-md-4 form-group required">
                              <label class="control-label">Caller ID</label>
                              <input
                                type="text"
                                id="display_name"
                                name="display_name"
                                v-model="value.voip.display_name"
                                v-validate="callerIdRules"
                                class="form-control"
                                placeholder="JaneA"
                              />
                              <div
                                class="help text-danger"
                                v-show="errors.has('display_name')"
                              >
                                {{ errors.first("display_name") }}
                              </div>
                            </div>
                            <div class="col-md-4 form-group required">
                              <label class="control-label">VOiP Number</label>
                              <input
                                type="text"
                                id="sip_number"
                                name="sip_number"
                                v-model="value.voip.sip_number"
                                v-validate="sipNumberRules"
                                class="form-control"
                                placeholder="0123456789"
                              />
                              <div
                                class="help text-danger"
                                v-show="errors.has('sip_number')"
                              >
                                {{ errors.first("sip_number") }}
                              </div>
                            </div>
                            <div class="col-md-4 form-group required">
                              <label class="control-label">SIP Server</label>
                              <el-input
                                type="text"
                                id="sip_server"
                                name="sip_server"
                                placeholder="Enter value"
                                v-model="value.voip.sip_server"
                                v-validate="sipServerRules"
                                class="input-with-select"
                                @input="validateField('sip_server')"
                              >
                                <el-select
                                  v-model="value.voip.sip_server_type"
                                  slot="prepend"
                                  style="width: 110px"
                                  @change="validateField('sip_server')"
                                >
                                  <el-option
                                    label="Select"
                                    value=""
                                  ></el-option>
                                  <el-option label="IP" value="ip"></el-option>
                                  <el-option
                                    label="Domain"
                                    value="domain"
                                  ></el-option>
                                </el-select>
                              </el-input>

                              <div
                                class="help text-danger"
                                v-show="errors.has('sip_server')"
                              >
                                <span v-if="!value.voip.sip_server_type">
                                  Please select server type
                                </span>
                                <span
                                  v-else-if="
                                    value.voip.sip_server_type === 'ip' &&
                                    !isValidIP(value.voip.sip_server)
                                  "
                                >
                                  Please enter a valid IP address (e.g.,
                                  192.168.1.1)
                                </span>
                                <span
                                  v-else-if="
                                    value.voip.sip_server_type === 'domain' &&
                                    !isValidDomain(value.voip.sip_server)
                                  "
                                >
                                  Please enter a valid domain (e.g.,
                                  example.com)
                                </span>
                              </div>
                            </div>
                            <div class="col-md-4 form-group required">
                              <label class="control-label">SIP Port</label>
                              <input
                                type="text"
                                id="sip_port"
                                name="sip_port"
                                v-model="value.voip.sip_port"
                                v-validate="sipPortRules"
                                class="form-control"
                                placeholder="5060"
                              />
                              <div
                                class="help text-danger"
                                v-show="errors.has('sip_port')"
                              >
                                {{ errors.first("sip_port") }}
                              </div>
                            </div>
                            <div class="col-md-4 form-group required">
                              <label class="control-label">Login ID</label>
                              <input
                                type="text"
                                id="login_id"
                                name="login_id"
                                v-model="value.voip.login_id"
                                v-validate="loginIdRules"
                                class="form-control"
                                placeholder="Login ID"
                              />
                              <div
                                class="help text-danger"
                                v-show="errors.has('login_id')"
                              >
                                {{ errors.first("login_id") }}
                              </div>
                            </div>
                            <div class="col-md-4 form-group required">
                              <label class="control-label">Password</label>
                              <div class="password">
                                <input
                                  name="password"
                                  v-model.trim="value.voip.password"
                                  v-validate="passwordRules"
                                  class="form-control"
                                  placeholder="Password"
                                  :class="{
                                    'has-error': errors.has('password'),
                                  }"
                                  :type="showPassword ? 'text' : 'password'"
                                />
                                <span
                                  class="password-toggle"
                                  @click="togglePassword"
                                >
                                  <i
                                    :class="{
                                      'icon-eye-off': showPassword,
                                      'icon-eye': !showPassword,
                                    }"
                                  ></i>
                                </span>
                              </div>

                              <div
                                class="help text-danger"
                                v-show="errors.has('password')"
                              >
                                {{ errors.first("password") }}
                              </div>
                            </div>
                            <div class="col-md-12 form-group">
                              <div
                                class="card-common-title p-0 pt-3 d-flex align-items-center justify-content-between"
                              >
                                <label class="fw-500 m-0">Proxy Enable</label>
                                <el-switch
                                  v-model="value.voip.proxy_enable"
                                  active-color="#009E9D"
                                  inactive-color="#E5E5E5"
                                >
                                </el-switch>
                              </div>
                            </div>
                            <el-collapse-transition>
                              <div
                                class="col-md-12"
                                v-if="value.voip.proxy_enable"
                              >
                                <div class="row">
                                  <div class="col-md-6 form-group">
                                    <label class="control-label"
                                      >Proxy Server</label
                                    >
                                    <el-input
                                      type="text"
                                      id="proxy_server"
                                      name="proxy_server"
                                      placeholder="Enter value"
                                      v-model="value.voip.proxy_server"
                                      v-validate="proxyServerRules"
                                      class="input-with-select"
                                      @input="validateField('proxy_server')"
                                    >
                                      <el-select
                                        v-model="value.voip.proxy_server_type"
                                        slot="prepend"
                                        style="width: 110px"
                                        @change="validateField('proxy_server')"
                                      >
                                        <el-option
                                          label="Select"
                                          value=""
                                        ></el-option>
                                        <el-option
                                          label="IP"
                                          value="ip"
                                        ></el-option>
                                        <el-option
                                          label="Domain"
                                          value="domain"
                                        ></el-option>
                                      </el-select>
                                    </el-input>

                                    <div
                                      class="help text-danger"
                                      v-show="errors.has('proxy_server')"
                                    >
                                      <span
                                        v-if="!value.voip.proxy_server_type"
                                      >
                                        Please select server type
                                      </span>
                                      <span
                                        v-else-if="
                                          value.voip.proxy_server_type ===
                                            'ip' &&
                                          !isValidIP(value.voip.proxy_server)
                                        "
                                      >
                                        Please enter a valid IP address (e.g.,
                                        192.168.1.1)
                                      </span>
                                      <span
                                        v-else-if="
                                          value.voip.proxy_server_type ===
                                            'domain' &&
                                          !isValidDomain(
                                            value.voip.proxy_server
                                          )
                                        "
                                      >
                                        Please enter a valid domain (e.g.,
                                        example.com)
                                      </span>
                                    </div>
                                  </div>
                                  <div class="col-md-6 form-group">
                                    <label class="control-label"
                                      >Proxy Port</label
                                    >
                                    <input
                                      type="text"
                                      id="proxy_port"
                                      name="proxy_port"
                                      v-model="value.voip.proxy_port"
                                      v-validate="proxyPortRules"
                                      class="form-control"
                                      placeholder="5060"
                                    />
                                    <div
                                      class="help text-danger"
                                      v-show="errors.has('proxy_port')"
                                    >
                                      {{ errors.first("proxy_port") }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </el-collapse-transition>
                          </div>
                          <a
                            class="card-common-title p-0 py-3 fw-500 d-flex align-items-center justify-content-between"
                            data-toggle="collapse"
                            href="#PacketizationSettings"
                            role="button"
                            aria-expanded="true"
                            aria-controls="collapseExample"
                          >
                            Codec & Packetization Settings
                            <i class="icon-down"></i>
                          </a>
                          <div
                            class="collapse packetization"
                            id="PacketizationSettings"
                          >
                            <div class="table-responsive">
                              <table class="table">
                                <thead>
                                  <tr>
                                    <th>Type</th>
                                    <th>Packetization</th>
                                    <th>1</th>
                                    <th>2</th>
                                    <th>3</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(codec, index) in value.voip
                                      .codec_setting"
                                    :key="index"
                                  >
                                    <td>{{ codec.type }}</td>
                                    <td>
                                      <el-select
                                        v-model="codec.packetization"
                                        placeholder="Select"
                                      >
                                        <el-option
                                          label="10 ms"
                                          :value="10"
                                        ></el-option>
                                        <el-option
                                          label="20 ms"
                                          :value="20"
                                        ></el-option>
                                        <el-option
                                          label="30 ms"
                                          :value="30"
                                        ></el-option>
                                        <el-option
                                          label="40 ms"
                                          :value="40"
                                        ></el-option>
                                      </el-select>
                                    </td>
                                    <td v-for="i in 3" :key="i">
                                      <label class="radio">
                                        <input
                                          type="radio"
                                          :name="'priority-' + i"
                                          :value="i"
                                          :checked="codec.priority == i"
                                          @change="
                                            handlePriorityChange(index, i)
                                          "
                                        />
                                        <span class="radio-mark"></span>
                                      </label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-collapse-transition>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card" v-else>
            <div class="no-data py-5 px-3">
              <img
                v-if="value.voip.status_str !== 'REGISTERED'"
                src="/assets/images/no-data.svg"
                alt=""
              />
              <h3 class="my-3 card-common-title p-0">
                {{ value.voip.status_str }}
              </h3>
              <p class="m-0">{{ value.voip.status_msg }}</p>
            </div>
          </div>
        </form>
      </div>
    </section>
    <!-- update -->

    <div
      class="modal fade disable-voip-modal"
      tabindex="-1"
      role="dialog"
      :class="{ show: showModal === 'disableWarning' }"
      :style="showModal === 'disableWarning' ? 'display: block;' : ''"
      :aria-modal="showModal === 'disableWarning' ? 'true' : null"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="icon-alert-triangle"></i> Warning
            </h5>
            <!--            <button type="button" class="close" @click="closeModal" aria-label="Close">-->
            <!--              <i class="icon-close"></i>-->
            <!--            </button>-->
          </div>
          <div class="modal-body">
            <p>
              Disabling VoIP will immediately unregister this device from the
              SIP server. Active calls will be dropped. Are you sure you want to
              continue?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="enableVoip">
              Cancel
            </button>
            <button type="button" class="btn" @click="disableVoip">
              Disable VoIP
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import ElCollapseTransition from "element-ui/lib/transitions/collapse-transition";

export default {
  name: "VoIPConfiguration",
  components: {
    ElCollapseTransition,
  },

  data() {
    return {
      is_loading: false,
      is_edit: false,
      voip_setting_enable: false,
      showPassword: false,
      voip_api_url: "/get-voip-configuration",
      value: {
        voip: {
          voip_enable: false,
          codec_setting: [],
          provision_history: { creator: {} },
        },
      },
      codecs: [
        { type: "G711-ulaw", packetization: 20, priority: 1 },
        { type: "G711-alaw", packetization: 20, priority: 2 },
        { type: "G729", packetization: 20, priority: 3 },
      ],
      showModal: null,
      voip_restore_data_str: "",
    };
  },
  computed: {
    isValidIP() {
      return (ip) =>
        /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          ip
        );
    },
    isValidDomain() {
      return (domain) => {
        const domainRegex =
          /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;

        return domainRegex.test(domain);
      };
    },
    callerIdRules() {
      let rules = {};
      if (this.value.voip.voip_enable) {
        rules = {
          required: true,
          max: 32,
        };
      }
      return rules;
    },
    sipNumberRules() {
      if (!this.value.voip.voip_enable) {
        return {};
      }

      return {
        required: true,
        regex: /^(?:\+|00)?\d+(?:\\;ext=\d+)?$/,
      };
    },
    sipPortRules() {
      let rules = {};
      if (this.value.voip.voip_enable) {
        rules.required = true;
        rules.numeric = true;
        rules.min_value = 0;
        rules.max_value = 65535;
      }
      return rules;
    },
    loginIdRules() {
      let rules = {};
      if (this.value.voip.voip_enable) {
        rules.required = true;
        rules.max = 30;
        // rules.regex = /^[a-zA-Z0-9]+$/;
      }
      return rules;
    },
    sipServerRules() {
      let rules = {};
      if (this.value.voip.voip_enable) {
        rules.required = true;
        if (this.value.voip.sip_server_type) {
          if (this.value.voip.sip_server_type === "ip") {
            rules.regex =
              /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          } else if (this.value.voip.sip_server_type === "domain") {
            rules.regex =
              /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
          }
        }
      }
      return rules;
    },
    passwordRules() {
      let rules = {};
      if (this.value.voip.voip_enable) {
        rules.required = true;
        rules.max = 30;
      }
      return rules;
    },
    proxyServerRules() {
      let rules = {};
      if (this.value.voip.voip_enable && this.value.voip.proxy_enable) {
        rules.required = true;
        if (this.value.voip.proxy_server_type) {
          if (this.value.voip.proxy_server_type === "ip") {
            rules.regex =
              /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          } else if (this.value.voip.proxy_server_type === "domain") {
            rules.regex =
              /^(?=.{1,253}$)(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,63}$/;
          }
        }
      }
      return rules;
    },
    proxyPortRules() {
      let rules = {};
      if (this.value.voip.voip_enable && this.value.voip.proxy_enable) {
        rules.required = true;
        rules.numeric = true;
        rules.min_value = 0;
        rules.max_value = 65535;
      }
      return rules;
    },
  },
  watch: {
    "value.voip.voip_enable"(newValue, oldValue) {
      if (this.is_loading) return;

      if (oldValue === true && newValue === false) {
        this.openModal("disableWarning");
      }
    },
  },
  methods: {
    handleSubmission() {
      console.log("handleSubmission");
      const _this = this;
      this.$validator
        .validateAll()
        .then((result) => {
          console.log("validateAll", result);
          /*if (!_this.value.voip?.voip_enable) {
            _this.value.voip = {}
          }*/
          let voipValidationPassed = true;
          if (_this.value.voip?.voip_enable) {
            const sipValid = _this.validateField("sip_server");
            const proxyValid = _this.validateField("proxy_server");

            voipValidationPassed = sipValid && proxyValid;
          }
          console.log("voipValidationPassed", voipValidationPassed);

          if (result && voipValidationPassed) {
            _this.is_loading = true;
            let api_url = "voip_configuration";
            let method = "POST";
            if (_this.is_edit) {
              api_url = "/voip_configuration/" + _this.value.voip.id;
              method = "PUT";
            }

            api_url += "?accountId=" + LocalStorage.get("accountId");
            const payload = {
              ..._this.value.voip,
            };
            axios({
              method: method,
              url: api_url,
              data: payload,
              headers: { "Content-Type": "application/json" },
            })
              .then(async (response) => {
                this.$toaster.success(response.data.message);

                // Reload configuration from backend
                await this.initialize();
              })
              .catch((errors) => {
                if (errors.response && errors.response.data) {
                  const status = errors.response.status;
                  const errorDetails = errors.response.data.errors || {};
                  console.log(errorDetails);
                  if (
                    errorDetails.hasOwnProperty("code") &&
                    errorDetails.code == 501
                  ) {
                    // If API sends a general message (non-field specific)
                    if (errorDetails.message) {
                      _this.$toaster.error(errorDetails.message);
                    }
                  } else {
                    // Map API errors to VeeValidate field names
                    Object.keys(errorDetails).forEach((key) => {
                      const simpleKey = key.split(".").pop(); // last part after dot
                      const message = errorDetails[key][0];

                      // Toast notification
                      _this.$toaster.error(message);

                      // Inline VeeValidate error
                      _this.errors.add({
                        field: simpleKey,
                        msg: message,
                      });
                    });
                  }
                } else {
                  _this.$toaster.error("An unexpected error occurred.");
                }
              })
              .finally(() => {
                _this.is_loading = false;
              });
          }
        })
        .catch((error) => {
          console.log("error " + error);
          // reject(error)
        });
    },
    validateField(fieldName) {
      if (!this.value.voip.voip_enable) {
        this.errors.remove("sip_server");
        this.errors.remove("proxy_server");
        return true;
      }
      if (fieldName === "sip_server") {
        const server = this.value.voip.sip_server;
        const type = this.value.voip.sip_server_type;

        this.errors.remove("sip_server");

        if (!type) {
          this.errors.add({
            field: "sip_server",
            msg: "Please select server type",
          });
          return false;
        }

        if (type === "ip" && !this.isValidIP(server)) {
          this.errors.add({
            field: "sip_server",
            msg: "Please enter a valid IP address",
          });
          return false;
        }

        if (type === "domain" && !this.isValidDomain(server)) {
          this.errors.add({
            field: "sip_server",
            msg: "Please enter a valid domain",
          });
          return false;
        }

        return true;
      } else if (fieldName === "proxy_server") {
        if (!this.value.voip.proxy_enable) {
          this.errors.remove("proxy_server");
          return true;
        }

        const server = this.value.voip.proxy_server;
        const type = this.value.voip.proxy_server_type;

        this.errors.remove("proxy_server");

        if (!type) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please select server type",
          });
          return false;
        }

        if (type === "ip" && !this.isValidIP(server)) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please enter a valid IP address",
          });
          return false;
        }

        if (type === "domain" && !this.isValidDomain(server)) {
          this.errors.add({
            field: "proxy_server",
            msg: "Please enter a valid domain",
          });
          return false;
        }

        return true;
      }
      return true;
    },
    handlePriorityChange(changedIndex, newPriority) {
      this.value.voip.codec_setting.forEach((codec, idx) => {
        if (idx !== changedIndex && codec.priority + "" === newPriority + "") {
          codec.priority = this.value.voip.codec_setting[changedIndex].priority;
        }
      });
      this.value.voip.codec_setting[changedIndex].priority = newPriority;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    getVoipData: function () {
      return new Promise((resolve, reject) => {
        axios
          .get(this.voip_api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => resolve(response))
          .catch((error) => {
            console.error("getVoipData error:", error);
            reject(error);
          });
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/provisions/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get("accountId") },
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      try {
        const response = await this.getVoipData();
        const data = response.data;

        this.is_edit = data.id !== undefined && data.id !== null;

        this.voip_setting_enable = data.voip_setting_enable === true;

        this.value.voip = {
          ...data,
          voip_enable: data.voip_enable === true,
          proxy_enable: data.proxy_enable === true,
          sip_port: data.sip_port ?? 5060,
          codec_setting:
            Array.isArray(data.codec_setting) && data.codec_setting.length > 0
              ? data.codec_setting
              : this.codecs.map((codec) => ({ ...codec })),
          provision_history: {
            ...(data.provision_history || {}),
            creator: data.provision_history?.creator || {},
          },
        };

        this.voip_restore_data_str = JSON.stringify(this.value.voip);
      } catch (error) {
        console.error("VoIP initialization failed:", error);
        this.$toaster.error("Unable to load VoIP configuration.");
      } finally {
        this.is_loading = false;
      }
    },
    disableVoip() {
      this.showModal = null;
    },
    enableVoip() {
      this.value.voip.voip_enable = true;
      this.showModal = null;
    },
    openModal(modalId) {
      this.showModal = modalId;
    },
    restoreData() {
      this.value.voip = JSON.parse(this.voip_restore_data_str);
    },
  },
  mounted() {
    this.initialize();
  },
  created() {
    // this.$emit("update:layout", MasterLayout);
    this.$validator.localize("en", {
      attributes: {
        display_name: "Caller ID",
        sip_number: "VOip number",
        sip_port: "Sip Port",
        sip_server: "SIP Server",
        login_id: "Login ID",
        password: "Password",
        proxy_server: "Proxy Server",
        proxy_port: "Proxy Port",
      },
      messages: {
        // Define a custom message for the 'required' rule
        // Use {_field_} placeholder to inject the mapped name
        required: (field) => `The ${field} is required`,
        alpha_num: (field) => `The ${field} must be alphanumeric.`, // Example of a message that already uses the placeholder
      },
    });
  },
};
</script>

<style scoped>
.card-body {
  min-height: 20px;
}
.badge {
  font-weight: 600;
  padding: 12px 15px;
}
a[aria-expanded="true"] i::before {
  content: "\e917";
}

a[aria-expanded="true"]:hover {
  color: #111;
}
.btn-cancel {
  border: 1px solid #657182;
  color: #657182 !important;
  background: none !important;
}
.theme-audra .table > tbody > tr > td:first-child {
  color: #657182;
}

.table > tbody > tr > td:first-child {
  font-weight: normal;
}

.theme-audra .table > thead > tr > th {
  background-color: #f9f9f9;
  border: none !important;
  color: #1e1e1e;
}

.theme-audra .table > thead > tr > th:first-child {
  border-radius: 8px 0 0 8px;
}

.theme-audra .table > thead > tr > th:last-child {
  border-radius: 0 8px 8px 0;
}

.table td,
.table th {
  padding: 1rem;
  vertical-align: middle;
  border: none !important;
}

.table > tbody > tr > td:last-child,
.table > thead > tr > th:last-child {
  text-align: start;
}

.table > tbody > tr:not(:last-child) {
  border-bottom: 1px solid rgba(229, 229, 229, 0.7);
}
.modal {
  z-index: 9999;
}

.modal-body p {
  font-size: 0.9rem;
  line-height: 1.5rem;
}
</style>
